module.exports = __webpack_public_path__ + "media/categories-photos/21-fc7676f3.webp";